import axios from 'axios'
import getConfig from '../config'
const { API_BASE_URI } = getConfig()

export async function getUser (userId) {
  const response = await axios({
    method: 'get',
    url: `${API_BASE_URI}/users/${userId}`
  })
  return response.data
}

export async function createUser (data) {
  const response = await axios({
    method: 'post',
    url: `${API_BASE_URI}/users`,
    data: data
  })
  return response.data
}

export async function updateUser (userId, data) {
  const response = await axios({
    method: 'put',
    url: `${API_BASE_URI}/users/${userId}`,
    data: data
  })
  return response.data
}

export async function authenticate (email, password) {
  const response = await axios({
    method: 'post',
    url: `${API_BASE_URI}/users/authenticate`,
    data: { email, password }
  })
  return response.data
}

export async function listUsers ({offset, limit, sort}) {
  let url = `${API_BASE_URI}/users?offset=${offset}&limit=${limit}`
  url += sort ? `&sort=${sort}` : ''
  const response = await axios({
    method: 'get',
    url
  })
  return response.data
}



// WEBPACK FOOTER //
// ./src/api/users.js